import styles from './../../assets/styles/default.scss';
import { createTheme } from '@material-ui/core/styles';

const sicrediGreen = {
  main: styles.sicrediGreen,
  light: styles.sicrediGreenLight,
  dark: styles.sicrediGreenDark,
  contrastText: styles.sicrediGreenContrast,
};

const pufvBlue = {
  main: styles.pufvBlue,
  light: styles.pufvBlueLight,
  dark: styles.pufvBlueDark,
  contrastText: styles.pufvBlueContrast,
};

const pufvYellow = {
  main: styles.pufvYellow,
  light: styles.pufvYellowLight,
  dark: styles.pufvYellowDark,
  contrastText: styles.pufvYellowContrast,
};

const error = {
  main: styles.error,
  light: styles.errorLight,
  dark: styles.errorDark,
  contrastText: styles.errorContrast,
};

const warning = {
  main: styles.warning,
  light: styles.warningLight,
  dark: styles.warningDark,
  contrastText: styles.warningContrast,
};

const primaryFontFamily = styles.defaultFontFamily;

const defaultTypography = {
  useNextVariants: true,
  body1: {
    fontFamily: primaryFontFamily,
  },
  body1Next: {
    fontFamily: primaryFontFamily,
  },
  body2: {
    fontFamily: primaryFontFamily,
  },
  body2Next: {
    fontFamily: primaryFontFamily,
  },
  button: {
    fontFamily: primaryFontFamily,
  },
  buttonNext: {
    fontFamily: primaryFontFamily,
  },
  caption: {
    fontFamily: primaryFontFamily,
  },
  captionNext: {
    fontFamily: primaryFontFamily,
  },
  display1: {
    fontFamily: primaryFontFamily,
  },
  display2: {
    fontFamily: primaryFontFamily,
  },
  display3: {
    fontFamily: primaryFontFamily,
  },
  display4: {
    fontFamily: primaryFontFamily,
  },
  fontFamily: primaryFontFamily,
  h1: {
    fontFamily: primaryFontFamily,
  },
  h2: {
    fontFamily: primaryFontFamily,
  },
  h3: {
    fontFamily: primaryFontFamily,
  },
  h4: {
    fontFamily: primaryFontFamily,
  },
  h5: {
    fontFamily: primaryFontFamily,
  },
  h6: {
    fontFamily: primaryFontFamily,
  },
};

const genericCardButtonTheme = {
  typography: defaultTypography,

  overrides: {
    MuiButton: {
      root: {
        display: 'block !important',
        borderRadius: '20px',
      },
      label: {
        textTransform: 'none',
      },
    },
  },

  palette: {
    primary: sicrediGreen,
  },
};

export const genericCardButtonThemes = {
  default: createTheme({
    typography: defaultTypography,
    ...genericCardButtonTheme,
  }),
  pufvBlue: createTheme({
    ...genericCardButtonTheme,
    palette: {
      primary: pufvBlue,
    },
  }),
  pufvYellow: createTheme({
    ...genericCardButtonTheme,
    palette: {
      primary: pufvYellow,
    },
  }),
  error: createTheme({
    ...genericCardButtonTheme,
    palette: {
      primary: error,
    },
  }),
  warning: createTheme({
    ...genericCardButtonTheme,
    palette: {
      primary: warning,
    },
  }),
};

export const getGenericCardButtonTheme = (themeName) => {
  const theme = themeName || 'default';
  if (theme && genericCardButtonThemes[theme]) {
    return genericCardButtonThemes[theme];
  }
  return genericCardButtonThemes.default;
};
